<template>
    <div v-if="show">
        <div class="fixed z-30 inset-0 overflow-y-auto">
            <div class="flex items-center justify-center">
                <!--
                  Background overlay, show/hide based on modal state.

                  Entering: "ease-out duration-300"
                    From: "opacity-0"
                    To: "opacity-100"
                  Leaving: "ease-in duration-200"
                    From: "opacity-100"
                    To: "opacity-0"
                -->
                <div class="fixed inset-0 transition-opacity">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                    <div v-if="showCloseButton" class="absolute top-0 right-0 cursor-pointer mr-8 mt-8 text-white"
                         @click.prevent="$emit('close')">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </div>
                </div>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
                <!--
                  Modal panel, show/hide based on modal state.

                  Entering: "ease-out duration-300"
                    From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    To: "opacity-100 translate-y-0 sm:scale-100"
                  Leaving: "ease-in duration-200"
                    From: "opacity-100 translate-y-0 sm:scale-100"
                    To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                -->
                <div class="h-screen w-full inline-block align-bottom bg-transparent text-left overflow-hidden
                shadow-xl transform transition-all sm:align-middle sm:max-w-lg sm:w-full sm:rounded-md sm:max-h-full sm:max-h-95vh md:max-h-90vh"
                     role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                    <div class="rounded-lg bg-white h-full w-full">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ChannelContainerModal",
    props: {
        show: {
            type: Boolean,
            required: true,
            default: false
        },
        showCloseButton: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
};
</script>

<style scoped>
.h-90vh {
    height: 90vh;
}
</style>
